/**
 * 매칭 token highlight — query token 색반전 노란 배경. 다중 token 지원.
 * (LeftAiPanel 에서 추출한 공용 유틸 — EvidencePanel 의 사본은 추후 과제)
 */
import React from "react";

export function buildSearchHighlightTokens(query, backendTokens = []) {
  const q = String(query || "").trim().toLowerCase();
  const queryTokens = q
    ? [q, ...q.split(/[\s,;·/()[\]{}]+/)]
    : [];
  const suppliedTokens = Array.isArray(backendTokens) ? backendTokens : [];
  const normalized = [...new Set([...queryTokens, ...suppliedTokens]
    .map((token) => String(token || "").trim().toLowerCase())
    .filter((token) => token.length >= 2))];
  // 백엔드 영문 검색은 단·복수형을 같은 어휘로 찾을 수 있으므로 화면 강조도
  // masks → mask처럼 사용자가 실제로 보는 표기에 맞춘다.
  const displayVariants = normalized
    .filter((token) => /^[a-z]{4,}s$/.test(token))
    .map((token) => token.slice(0, -1));
  return [...new Set([...normalized, ...displayVariants])]
    .sort((a, b) => b.length - a.length);
}

export function textHasHighlightToken(text, tokens) {
  const source = String(text || "").toLowerCase();
  return !!source && (tokens || []).some((token) => {
    const needle = String(token || "").trim().toLowerCase();
    return needle.length >= 2 && source.includes(needle);
  });
}

export function buildHighlightSnippet(text, tokens, contextLength = 52) {
  const source = String(text || "");
  const lower = source.toLowerCase();
  let foundAt = -1;
  let foundLength = 0;
  for (const token of tokens || []) {
    const needle = String(token || "").trim().toLowerCase();
    if (needle.length < 2) continue;
    const index = lower.indexOf(needle);
    if (index !== -1 && (foundAt === -1 || index < foundAt)) {
      foundAt = index;
      foundLength = needle.length;
    }
  }
  if (foundAt === -1) return "";
  const start = Math.max(0, foundAt - contextLength);
  const end = Math.min(source.length, foundAt + foundLength + contextLength);
  return `${start > 0 ? "…" : ""}${source.slice(start, end)}${end < source.length ? "…" : ""}`;
}

export function highlightTokens(text, tokens) {
  if (!text || !tokens || tokens.length === 0) return text;
  const source = String(text);
  const lowText = source.toLowerCase();
  const ranges = [];
  for (const tk of tokens) {
    const needle = String(tk || "").trim().toLowerCase();
    if (needle.length < 2) continue;
    let p = 0;
    while ((p = lowText.indexOf(needle, p)) !== -1) {
      ranges.push([p, p + needle.length]);
      p += needle.length;
    }
  }
  if (ranges.length === 0) return text;
  ranges.sort((a, b) => a[0] - b[0]);
  const merged = [];
  for (const r of ranges) {
    if (merged.length && merged[merged.length - 1][1] >= r[0]) {
      merged[merged.length - 1][1] = Math.max(
        merged[merged.length - 1][1],
        r[1],
      );
    } else {
      merged.push([r[0], r[1]]);
    }
  }
  const parts = [];
  let last = 0;
  merged.forEach(([s, e], i) => {
    if (last < s) parts.push(source.slice(last, s));
    parts.push(
      <mark
        key={`m_${i}`}
        style={{ background: "#fff3a0", color: "inherit", padding: "0 1px" }}
      >
        {source.slice(s, e)}
      </mark>,
    );
    last = e;
  });
  if (last < source.length) parts.push(source.slice(last));
  return <>{parts}</>;
}
